import * as Sentry from "@sentry/react";

const SENTRY_DSN_URL = import.meta.env.VITE_SENTRY_DSN || "https://1b9ba4edae9444e88247d4e4e0c2e061@crashlog.lkis.de/40";

/**
 * Configures the Sentry JS client (https://github.com/getsentry).
 */
export function initSentry() {
  console.debug("GIT_TAG: " + import.meta.env.VITE_GIT_TAG);
  console.debug("GIT_COMMIT: " + import.meta.env.VITE_GIT_COMMIT);
  if (import.meta.env.DEV || window.location.hostname === "localhost") {
    console.log("DEV mode => skipping sentry init");
    // Sentry in local development
    return;
  }

  // Installs an `window.onerror` listener
  Sentry.init({
    dsn: SENTRY_DSN_URL,
    release: import.meta.env.VITE_GIT_TAG as string,
    environment: window.location.hostname,
  });
  Sentry.configureScope(scope => {
    scope.setTag("git_tag", import.meta.env.VITE_GIT_TAG || "undefined");
    scope.setTag("git_commit", import.meta.env.VITE_GIT_COMMIT || "undefined");
  });
  if (window.onunhandledrejection) {
    window.onunhandledrejection = (e: PromiseRejectionEvent) => {
      Sentry.captureException(e.reason);
    };
  }
}
